<div class="business-vip-details-root">
  <mat-card class="main-card">
    <div class="card-title">
      {{ 'business-levels' | transloco }}  
    </div>

    <mat-card 
      class="card"
      [ngClass]="{ 'card-disabled': isTimelineDisabled(item.familyPk) }" 
      *ngFor="let item of businessSummary!.businessLevels">

      <div class="series-name">
        {{ 'business-series' | transloco }} {{item.familyName}}
      </div>
      <div class="vip-levels">
        <div class="vip-card">
          <mat-icon>credit_card</mat-icon>
          <div class="vip-card-name">
            {{item.description}}
          </div>
        </div>
        <div class="vip-arrow" *ngIf="getNextLevel(item.familyPk)">
          <mat-icon>
            arrow_right_alt
          </mat-icon>
        </div>
        <div class="vip-card" *ngIf="getNextLevel(item.familyPk)">
          <mat-icon>credit_card</mat-icon>
          <div class="vip-card-name">
            {{getNextLevel(item.familyPk).description}}
          </div>
        </div>
      </div>
      <div class="actions">
        <div>
          <app-icon-button 
            id="lnr-reissue-vip-coupon-button" 
            v2 borderless 
            icon="credit_card"
            *ngIf="businessSummary!.active && !viewOnly && !isTimelineDisabled(item.familyPk)"
            (clickAction)="openUpdateVipLevelModal(item.familyPk, item.familyName)"> 
            {{ 'update-vip-level' | transloco }}  
          </app-icon-button>
        </div>
        <div>
          <app-icon-button
            *ngIf="businessSummary!.active && canReissueVIPCoupon(item) && !viewOnly && !isTimelineDisabled(item.familyPk)"
            id="lnr-reissue-vip-coupon-button" 
            v2 whiteBackground 
            borderless 
            icon="cached" 
            (clickAction)="openReissueVIPCouponConfirmation(item)"> 
            {{ 'reissue-vip-coupon' | transloco }} 
          </app-icon-button>
        </div>
      </div>
    </mat-card>
  </mat-card>
  
</div>
